import { isClientEnvironment } from '@core/configuration';
import { z } from '@core/validator';
var getAllowedHostsForRedirectUri = function getAllowedHostsForRedirectUri() {
    var allowedHosts = [
        /\.cloud\.coveo\.com$/
    ];
    if (!isClientEnvironment()) {
        allowedHosts.push('localhost');
        allowedHosts.push(/\.corp\.coveo\.com$/);
        allowedHosts.push(/\.stratus\.coveo\.com$/);
    }
    return allowedHosts;
};
export var getCleanRedirectURI = function getCleanRedirectURI(redirectUri) {
    var allowedHosts = getAllowedHostsForRedirectUri();
    var allowedProtocols = [
        'https:',
        'http:'
    ];
    var strictAllowlistedUrlSchema = z.string().url().refine(function(url) {
        try {
            var parsedUrl = new URL(url);
            return allowedProtocols.includes(parsedUrl.protocol) && allowedHosts.some(function(hostOrRegExp) {
                return typeof hostOrRegExp === 'string' ? hostOrRegExp === parsedUrl.hostname : hostOrRegExp.test(parsedUrl.hostname);
            });
        } catch (unused) {
            return false;
        }
    });
    var redirectURL;
    try {
        redirectURL = new URL(redirectUri);
        strictAllowlistedUrlSchema.parse(redirectUri);
    } catch (unused) {
        redirectURL = new URL(window.location.href);
    }
    redirectURL.searchParams.get('code') && redirectURL.searchParams.delete('code');
    var hashHasQueryString = /[^\?]+(\?.*)/.test(redirectURL.hash);
    var hashDoesNotExists = redirectURL.hash === '';
    var redirectParamAlreadyIncluded = redirectURL.hash.includes('redirect=true');
    if (hashDoesNotExists) {
        redirectURL.hash = '#/?redirect=true';
    } else if (!hashHasQueryString) {
        redirectURL.hash = redirectURL.hash + '?redirect=true';
    } else if (!redirectParamAlreadyIncluded) {
        redirectURL.hash = redirectURL.hash + '&redirect=true';
    }
    // URL.toString() omits the / between pathname and search/hash when pathname
    // doesn't end with /. Normalize it so hash-routed URLs like commerce/#/org are correct.
    // Skip file paths (e.g. index.html, platformOauthRedirectHandler.html) to avoid breaking redirects.
    if (!redirectURL.pathname.endsWith('/') && !/\.\w+$/.test(redirectURL.pathname)) {
        redirectURL.pathname += '/';
    }
    return redirectURL.toString();
};

//# sourceMappingURL=getCleanRedirectURI.js.map